import React from "react";

export const ChangeCursor = () => {
    if (document.body.style.cursor === "progress") {
        document.body.style.setProperty('cursor', 'default');
    } else {
        document.body.style.setProperty('cursor', 'progress');
    }
}
